export const CHECKLIST_ADD_ITEM = "CHECKLIST_ADD_ITEM";
export const CHECKLIST_SAVE_ITEM = "CHECKLIST_SAVE_ITEM";
export const CHECKLIST_REMOVE_ITEM = "CHECKLIST_REMOVE_ITEM";
export const CHECKLIST_CLEAR_STATE = "CHECKLIST_CLEAR_STATE";
export const CHECKLIST_SAVE_LABEL = "CHECKLIST_SAVE_LABEL";
export const CHECKLIST_SAVE_DESCRIPTION = "CHECKLIST_SAVE_DESCRIPTION";
export const CHECKLIST_SET_CHECKLISTS = "CHECKLIST_SET_CHECKLISTS";
export const CHECKLIST_SET_CHECKLIST = "CHECKLIST_SET_CHECKLIST";
export const CHECKLIST_SET_CURRENT_STATE = "CHECKLIST_SET_CURRENT_STATE";
export const CHECKLIST_SAVE_CHECKLIST = "CHECKLIST_SAVE_CHECKLIST";
export const CHECKLIST_SET_MODE = "CHECKLIST_SET_MODE";
export const CHECKLIST_SELECT_CHECKLIST = "CHECKLIST_SELECT_CHECKLIST";
export const CHECKLIST_SET_LOADING = "CHECKLIST_SET_LOADING";
export const CHECKLIST_SET_CURRENT_CHECKLIST = "CHECKLIST_SET_CURRENT_CHECKLIST";
export const CHECKLIST_REORDER_ITEMS = "CHECKLIST_REORDER_ITEMS";
